import React from "react";

/**
 * Pastille d'état d'une commande.
 *
 * Les clés sont les valeurs brutes de `orders.state`, pas un regroupement
 * maison : le manager lit les mêmes états que le reste de l'outil.
 *
 * La couleur suit l'avancement — lavande de plus en plus soutenu à mesure que
 * la commande progresse, teal une fois rendue. Elle ne porte jamais
 * l'information seule : le libellé est toujours présent.
 */
export const STATE_LABELS = {
  confirmed: "Confirmed",
  picked_up: "Picked up",
  dropped_at_shop: "Dropped at shop",
  dropped_at_laundry: "Dropped at laundry",
  processed: "Processed",
  ready_for_delivery: "Ready for delivery",
  ready_for_shop: "Ready for shop",
  delivery: "Delivered",
  retrieved_by_user: "Retrieved by user",
};

export const STATE_COLORS = {
  confirmed: { bg: "#EDEEF7", fg: "#5A5F80" },
  picked_up: { bg: "#DDE1F6", fg: "#3D4586" },
  dropped_at_shop: { bg: "#DDE1F6", fg: "#3D4586" },
  dropped_at_laundry: { bg: "#C7CEEF", fg: "#2B3268" },
  processed: { bg: "#A9B2E6", fg: "#1B1F3A" },
  ready_for_delivery: { bg: "#8E99E4", fg: "#fff" },
  ready_for_shop: { bg: "#8E99E4", fg: "#fff" },
  delivery: { bg: "#DFF2F2", fg: "#1F7A7F" },
  retrieved_by_user: { bg: "#DFF2F2", fg: "#1F7A7F" },
};

const FALLBACK = { bg: "#EDEEF7", fg: "#5A5F80" };

export const stateLabel = (state, t) => {
  const label = STATE_LABELS[state] || state || "—";
  return t ? t(label) : label;
};

const StatusPill = ({ state, t, size }) => {
  const colors = STATE_COLORS[state] || FALLBACK;

  return (
    <span
      className={`mgr-pill${size === "lg" ? " mgr-pill--lg" : ""}`}
      style={{ background: colors.bg, color: colors.fg }}
    >
      {stateLabel(state, t)}
    </span>
  );
};

export default StatusPill;
